<section class="asset-management-section">
  <ts-page-header [displaySeparationBorder]="true">
    <ng-container page-header-title>
      <p class="font-ts-header-title text-ts-header-title">Consolidated Chart of Accounts</p>
    </ng-container>
    <ng-container page-header-action-buttons>
      <section class="flex flex-row items-center gap-2">
        <ts-button
          variant="primary"
          icon="ts_plus"
          (click)="manageCategoryAccount.emit()"
          [disabled]="hasUnsavedChanges | async"
          >Add Account
        </ts-button>
      </section>
    </ng-container>
  </ts-page-header>

  <ag-grid-angular
    id="teams-grid"
    class="ag-theme-quartz"
    [rowData]="rowData"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [treeData]="true"
    [getDataPath]="getDataPath"
    [columnDefs]="colDefs"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    (rowDragEnd)="onRowDragEnd($event)"
    (rowDragLeave)="onRowDragLeave($event)"
    (rowDragMove)="onRowDragMove($event)"
  ></ag-grid-angular>
</section>
